export default () => {
  onmessage = event => {
    if (!event) return;
    const { Tags, PlotData } = event.data;
    const { Time } = PlotData;
    const TagsData = PlotData;
    delete TagsData.Time;

    if (Time.length > 0) {
      const timestampCol = { key: "TimeStamp", header: "Date-Time", width: 25 };

      const excelHeaders = Tags.reduce(
        (result, { TagId, Units }) => {
          result.push({ key: TagId, header: `${TagId} (${Units})`, width: 15 });
          return result;
        },
        [timestampCol]
      );
      const excelData = Time.map((TimeStamp, idx) => {
        const rowData = { TimeStamp };
        Tags.forEach(({ TagId }) => (rowData[TagId] = TagsData[TagId][idx]));
        return rowData;
      });

      const descriptionRow = Tags.reduce(
        (result, { TagId, Description }) => {
          result[TagId] = Description ? `(${Description})` : "(description - N/A)";
          return result;
        },
        { TimeStamp: "" }
      );

      postMessage({ excelHeaders, excelData, descriptionRow });
    }
  };
};
